import styled, { css } from 'styled-components'

// const lstPxs = [60, 150, 90, 120, 120, 110, 100, 100, 200, 200]
// const sumPx = lstPxs.reduce((total, curr) => total + curr)
// const gridArr = lstPxs.map(
//     (item) => `minmax(${item}px, ${Math.round((item / sumPx) * 100)}fr)`
// )

const lstPxs = [115, 290, 170, 260, 170, 170, 170, 170, 170, 450, 500]
const gridArr = lstPxs.map((item) =>
    typeof item === 'number' ? `${item}px` : item
)

const extendStylesTable = css`
    .header,
    .row {
        grid-template-columns: ${gridArr.join(' ')};
    }
`

export { extendStylesTable }
